import Dialog from "../../../../components/Dialog";
import HeaderSelectDataTach from "./HeaderSelectDataTach";
import BodySelectData from "./BodySelectData";
import { WordChoosen } from "../../../../context/interfaces/IAdministratorTachContext";
import ActionSelectData from "./ActionSelectData";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";
import { initialModalFilterOptions } from "../../../../context/TachContext/initialFilterData";
import { IFilter } from "../../../../context/interfaces/IFilterDataContext";

interface ISelectData {
    isOpen: boolean;
    isGenerate: boolean;
}

const ModalSelectDataTach: React.FC<ISelectData> = ({ isOpen, isGenerate }) => {
    const {
        modalFilterOptions,
        setModalFilterOptions,
        filterGenerate,
        setFilterGenerate,
        filterPage,
        setFilterPage,
    } = useFilterData();
    const dialogClass = `${isOpen ? "visible-dialog" : "hidden-dialog"}`;
    const filter: IFilter = isGenerate ? filterGenerate : filterPage;

    const handleSetFilter = (newFilter: IFilter) => {
        if (isGenerate) {
            setFilterGenerate(newFilter);
        } else {
            setFilterPage(newFilter);
        }
    };

    const removingItems = () => {
        setModalFilterOptions(initialModalFilterOptions);
        handleSetFilter({
            ...filter,
            openModal: false,
        });
    };

    return (
        <Dialog
            openModal={isOpen}
            onHide={removingItems}
            className={dialogClass}
            size="width-600 modal-radius-8"
        >
            <HeaderSelectDataTach
                word={modalFilterOptions.key as WordChoosen}
            />
            <BodySelectData filter={filter} handleSetFilter={handleSetFilter} />
            <ActionSelectData
                handleSetFilter={handleSetFilter}
                removingItems={removingItems}
                filter={filter}
            />
        </Dialog>
    );
};

export default ModalSelectDataTach;
